import PropTypes from 'prop-types';
import { TrackingSummaryPropType } from '../prop-types/tracking-summary';
import { PackagePropType } from '../prop-types/package';
import { CurrencyPropType } from '../prop-types/currency';
import { ReturnStatusPropType } from '../prop-types/return-status';

export const ReturnShipmentPropType = PropTypes.shape({
  fulfillmentId: PropTypes.string,
  rmaNumber: PropTypes.string,
  note: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  trackingInformation: TrackingSummaryPropType,
  returnConfiguration: PropTypes.shape({
    carrierId: PropTypes.string,
    labelProviderId: PropTypes.string,
    sellerLabelProviderId: PropTypes.string,
    serviceId: PropTypes.string,
    shipFromId: PropTypes.string,
    shipTo: PropTypes.object,
    packages: PropTypes.arrayOf(PackagePropType),
    options: PropTypes.object,
    insuranceProvider: PropTypes.string,
  }),
  items: PropTypes.arrayOf(PropTypes.object),
  returnStatus: ReturnStatusPropType,
  voidedDateTime: PropTypes.string,
  receivedDateTime: PropTypes.string,
  createdDateTime: PropTypes.string,
  insuranceCost: CurrencyPropType,
  labelCost: CurrencyPropType,
});

/**
 * @typedef {object} ReturnShipmentPropType
 * @property {string} fulfillmentId
 * @property {string} rmaNumber
 * @property {string|object} note
 * @property {TrackingSummaryPropType} trackingInformation
 * @property {object} returnConfiguration
 * @property {string} returnConfiguration.carrierId
 * @property {string} returnConfiguration.labelProviderId
 * @property {string} returnConfiguration.sellerLabelProviderId
 * @property {string} returnConfiguration.serviceId
 * @property {string} returnConfiguration.shipFromId
 * @property {object} returnConfiguration.shipTo
 * @property {PackagePropType[]} returnConfiguration.packages
 * @property {object} returnConfiguration.options
 * @property {string} returnConfiguration.insuranceProvider
 * @property {object[]} items
 * @property {ReturnStatusPropType} returnStatus
 * @property {string} voidedDateTime
 * @property {string} receivedDateTime
 * @property {string} createdDateTime
 * @property {CurrencyPropType} insuranceCost
 * @property {CurrencyPropType} labelCost
 */
